export const title = '¡Hola!';
export const subTitle = '';
export const body = 'Bienvenido/a a Volbi, la aplicación que te acerca a esos '
+ 'locales a los que siempre vuelves';
export const getStamp = 'Marcar mi tarjeta';
